<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Work Order Count
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div class="col-md-12">
      <label class="mr-1">Team</label>
      <mat-slide-toggle class="tp-margin" (change)="changeWOView($event)"></mat-slide-toggle>
      <label class="ml-1">Customer</label>
      <button class="btn btn-success btn-sm btn-semi-round btn-demo bgBlue ml-3"
        (click)="showWOPopup(totalWOCount,0,0,data.statusPrecedence)">View All</button>
    </div>
    <div class="col-md-12 das-table pt-2">
      <table *ngIf="showTeam" class="table table-bordered table-hover">
        <thead>
          <tr class="das-table-row das-table-title">
            <th width="25%">Count</th>
            <th width="25%">Team</th>
            <th width="50%">{{tableHeader}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let items of woByTeam">
            <td><a (click)="showWOPopup(items.wOCount,items.teamKey,0,data.statusPrecedence)">{{items.wOCount}}</a></td>
            <td>{{items.team}}</td>
            <td>{{items.pendingMins}}</td>
          </tr>
          <tr>
            <td colspan="2"><strong>Total: </strong> {{totalWOCount}}</td>
            <td><strong>Call summary: </strong> Average {{teamAverageMins}} | Min: {{teamMinTime}} | Max:
              {{teamMaxTime}}</td>
          </tr>
        </tbody>
      </table>
      <table *ngIf="showCustomer" class="table table-bordered table-hover">
        <thead>
          <tr class="das-table-row das-table-title">
            <th width="25%">Count</th>
            <th width="25%">Customer</th>
            <th width="50%">{{tableHeader}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let items of woByCustomer">
            <td><a (click)="showWOPopup(items.wOCount,0,items.customerKey,data.statusPrecedence)">{{items.wOCount}}</a>
            </td>
            <td>{{items.customer}}</td>
            <td>{{items.pendingMins}}</td>
          </tr>
          <tr>
            <td colspan="2"><strong>Total: </strong> {{totalWOCount}}</td>
            <td><strong>Call summary: </strong> Average {{customerAverageMins}} | Min: {{customerMinTime}} | Max:
              {{customerMaxTime}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="onNoClick()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right"> Close </button>
</mat-dialog-actions>